module.exports = __webpack_public_path__ + "img/laptop-card-left.11a45322.png";